import { render, staticRenderFns } from "./LineObjectDrawer.vue?vue&type=template&id=54e6be3c&scoped=true&"
import script from "./LineObjectDrawer.vue?vue&type=script&lang=ts&"
export * from "./LineObjectDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./LineObjectDrawer.vue?vue&type=style&index=0&id=54e6be3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e6be3c",
  null
  
)

export default component.exports